import { DateCalendar } from "@mui/x-date-pickers";
import moment from "moment";
import { useState } from "react";
import { formatDate } from "../../utils/helpers";
import { PopoverMenu } from "../dropdown/popover";
import { CaretDown } from "../icon/downcaret";
import { TextInput } from "./textInput";

export const DateInput = ({
  placeholder = "",
  errors = "",
  title = "",
  date,
  minDate,
  referenceDate,
  setDate = () => {},
  onBlur,
  disabled = false,
  className = "",
  name,
}: {
  placeholder: string;
  name: string;
  errors?: string;
  title: string;
  date?: Date | null;
  minDate?: moment.Moment;
  referenceDate?: moment.Moment;
  onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  setDate?: (date: Date | null) => void;
  disabled?: boolean;
  className?: string;
}) => {
  const [clicked, setClicked] = useState<boolean>(false);

  if (disabled) {
    return (
      <button className="h-fit w-full text-left" type="button">
        <TextInput
          type="text"
          name={name}
          value={formatDate(date)}
          placeholder={placeholder}
          onChange={() => {}}
          onBlur={onBlur}
          hasTitle
          title={title}
          errors={errors}
          containerClassName=""
          readOnly
          customIcon={<CaretDown />}
          customIconPosition="right"
          inputClass="!cursor-not-allowed bg-grey-100"
        />
      </button>
    );
  }
  return (
    <PopoverMenu
      customMenuItems={({ close }) => {
        return (
          <div className={className}>
            <DateCalendar
              value={
                clicked && date === null ? moment(new Date()) : moment(date)
              }
              onChange={(newDate) => {
                setDate(newDate);
                close();
              }}
              minDate={minDate}
              referenceDate={referenceDate}
              disablePast
              views={["year", "month", "day"]}
              sx={{
                "& .MuiPickersDay-root.Mui-selected": {
                  backgroundColor: "#04000A !important",
                  color: "white",
                },
                "& .MuiPickersMonth-monthButton.Mui-selected": {
                  backgroundColor: "#04000A !important",
                  color: "white",
                },
                "& .MuiPickersYear-yearButton.Mui-selected": {
                  backgroundColor: "#04000A !important",
                  color: "white",
                },
              }}
            />
          </div>
        );
      }}
      menuClassName="rounded-xl bg-white !shadow-sm border"
      className="w-full"
      position="bottom"
    >
      <button className="h-fit w-full text-left" type="button">
        <TextInput
          type="text"
          name={name}
          value={formatDate(date)}
          placeholder={placeholder}
          onChange={() => {}}
          onBlur={(e) => {
            setClicked(true);
            onBlur(e);
          }}
          hasTitle
          title={title}
          errors={errors}
          containerClassName=""
          readOnly
          customIcon={<CaretDown />}
          customIconPosition="right"
          inputClass="!cursor-pointer"
        />
      </button>
    </PopoverMenu>
  );
};
